import { SCHOOLWIDE_TRAINING_LESSON_TYPE } from './constants'

export const MAX_SCHOOL_NAME_LENGTH = 30

export function formatDate(date) {
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  return date ? new Date(date).toLocaleString('en-US', options) : null
}

export function formatSchoolName(schoolName) {
  return schoolName?.length > MAX_SCHOOL_NAME_LENGTH
    ? schoolName.substring(0, MAX_SCHOOL_NAME_LENGTH) + '...'
    : schoolName
}

export const getHsActiveSites = activeSites => {
  if (!Array.isArray(activeSites)) return []
  return activeSites.filter(site =>
    site?.licenses?.some(license =>
      license?.product?.programCodes?.includes('HSP'),
    ),
  )
}

export const getSchoolNameForActiveSite = (hsActiveSites, hsActiveSiteId) => {
  const currentSite = hsActiveSites.find(site => site?.id === hsActiveSiteId)
  return currentSite?.name || null
}

export const shouldShowSchoolwideCompletionDetails = lessonType => {
  return !lessonType || lessonType === SCHOOLWIDE_TRAINING_LESSON_TYPE
}

const SCHOOLWIDE_TRAINING_ARTICLE_SLUG = 'program-kick-off'

/**
 * Temporary: LMS cannot create CMI on site (no-user) registrations.
 * Hide HS schoolwide mark-complete until that attempt path is restored.
 */
export const shouldHideSchoolwideTrainingMarkComplete = ({
  lessonType,
  pathname = '',
} = {}) => {
  if (lessonType === SCHOOLWIDE_TRAINING_LESSON_TYPE) return true
  const lastSegment = String(pathname)
    .split('/')
    .filter(Boolean)
    .pop()
  return lastSegment === SCHOOLWIDE_TRAINING_ARTICLE_SLUG
}

export const buildSchoolCompletionCommentary = ({
  completionSchool,
  schoolName,
  dateLine = '',
}) => {
  let commentary = ''

  if (completionSchool && schoolName)
    commentary = `${completionSchool} ${formatSchoolName(schoolName)}\n`

  if (dateLine) commentary += dateLine

  return commentary || null
}

export const buildCompletionDateLine = ({
  datePrefix,
  completedAt,
  formatDateFn = formatDate,
}) => {
  if (!datePrefix || !completedAt) return ''
  return `${datePrefix} ${formatDateFn(completedAt)}.`
}

export const DEFAULT_MARK_COMPLETE_BUTTON_TEXT = 'Mark Complete'
export const DEFAULT_MARK_COMPLETE_DONE_TEXT = 'Complete'

export function resolveMarkCompleteButtonText({
  isAdminUser,
  completionButtonLabelDefaultAdmin,
  completionButtonLabelDefaultAdminRef,
  completionButtonLabelDefaultEducator,
  completionButtonLabelDefaultEducatorRef,
}) {
  if (isAdminUser) {
    return (
      extractTextFromField(
        completionButtonLabelDefaultAdmin,
        completionButtonLabelDefaultAdminRef,
      ) || DEFAULT_MARK_COMPLETE_BUTTON_TEXT
    )
  }

  return (
    extractTextFromField(
      completionButtonLabelDefaultEducator,
      completionButtonLabelDefaultEducatorRef,
    ) || DEFAULT_MARK_COMPLETE_BUTTON_TEXT
  )
}

export function resolveMarkCompleteDoneText(
  completionLabelDone,
  completionLabelDoneRef,
) {
  return (
    extractTextFromField(completionLabelDone, completionLabelDoneRef) ||
    DEFAULT_MARK_COMPLETE_DONE_TEXT
  )
}

// for hs, we can just use the field
// for k8, we need to extract the text from the fieldRef
export function extractTextFromField(field, fieldRef) {
  if (typeof field === 'string') {
    return field
  }
  if (fieldRef?.length > 0) {
    return fieldRef[0]?.content || null
  }
  return null
}
